import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";

const $ = jQuery.noConflict();

export class ZIDXAccountSuperAdminUserEdit implements ZIDXPage {
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }

    getPageClass() {
        return "zidxAccountSuperAdminUserEditContainer";
    }


    render() {
        // console.log("SuperAdmin user edit");
        let self=this;
        const timezoneField = self.zidx.peakidxShadowRoot.querySelector("#user_timezone") as HTMLSelectElement | null;
        if(timezoneField && timezoneField.selectedIndex==0) {
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            for (let i = 0; i < timezoneField.options.length; i++) {
                if (timezoneField.options[i].value === timezone) {
                    timezoneField.selectedIndex = i;
                    break;
                }
            }
        }
        this.zidx.loadFunctions.push(function () {
            const user_id = $('input[name=user_id]', self.zidx.peakidxShadowRoot).val();
            function check(value: string, i: string) {
                let $selectContainer = $(`#lead_assign_user_id_container${i}`, self.zidx.peakidxShadowRoot);
                let $select = $(`#lead_assign_user_id${i}`, self.zidx.peakidxShadowRoot);
                if (value != '') {
                    $selectContainer.hide();
                    $select.empty();
                    return;
                }

                let site_id = $(`input[name=site${i}]`, self.zidx.peakidxShadowRoot).val();

                let obj = {
                    id: "ajaxSiteUsers",
                    method: "get",
                    postObj: {},
                    ignoreOldRequests: false,
                    callback: function (r: string) {
                        let response: any;
                        try {
                            response = $.parseJSON(r);
                        } catch (e) {
                            console.log("Invalid user search response");
                            return;
                        }
                        if (!response || !response.success || !Array.isArray(response.users)) {
                            console.log("User search failed", response && response.errorMessage);
                            return;
                        }
                        let users: any[] = response.users;
                        $select.empty();
                        $select.append(
                            $('<option/>', self.zidx.peakidxShadowRoot).val(0).text('-- SELECT --')
                        );

                        function displayName(user: any) {
                            return `${user.firstName} ${user.lastName} (${user.email})`
                        }

                        users.sort((a, b) => {
                            if (a.self) {
                                return -1;
                            }
                            if (b.self) {
                                return 1;
                            }
                            return displayName(a).localeCompare(displayName(b));
                        });

                        users.forEach(user => {
                                if (user.id == user_id) {
                                    return;
                                }
                                const $option = $('<option/>', self.zidx.peakidxShadowRoot).val(user.id);
                                if (user.self) {
                                    $option.text(`-- Myself --`)
                                } else {
                                    $option.text(displayName(user))
                                }
                                $select.append($option)
                            }
                        );
                        $selectContainer.show();
                    },
                    errorCallback: function (e: XMLHttpRequest) {
                        console.log(e.status);
                    },
                    url: '/account/sites/users/search?site_id=' + site_id
                };
                self.zidx.ajaxRequest(obj);
            }

            $('[zidx-none-unchecked-input]', self.zidx.peakidxShadowRoot).on("click", function (this: any) {
                const $this = $(this);
                check($this.val(), $this.parent().attr('zidx-i')!);
            })
                .each(function (i: any, element: any) {
                    const $this = $(element);
                    if ($this.is(':checked')) {
                        check($this.val(), $this.parent().attr('zidx-i')!);
                    }
                })
            ;
        });
    }
}